<template>
  <div v-if="!ShowFinalPage && !ShowExperiencePage" class="search-results">
    <div class="title-section">
      <h2>Community Metrics</h2>
      <h3>Analisi per <span class="company-name">{{ sessionstore.company_name }}</span></h3>
    </div>
    <div class="score-section">
      <div class="score-info">
        <p class="score-title">Abbiamo calcolato il tuo score</p>
        <div class="score-bar">
          <div class="score-fill" :style="{ width: sessionstore.communityScore * 10 + '%' }"></div>
        </div>
        <div class="score-value">{{ sessionstore.communityScore * 10 }} / 100</div>
      </div>
    </div>
    <div class="score-feedback">
      <div v-if="sessionstore.communityScore >= 0 && sessionstore.communityScore < 5" class="feedback-text">{{
        TextPlaceholders[0] }}</div>
      <div v-else-if="sessionstore.communityScore >= 5 && sessionstore.communityScore < 8" class="feedback-text">{{
        TextPlaceholders[1] }}</div>
      <div v-else class="feedback-text">{{ TextPlaceholders[2] }}</div>
    </div>
  </div>
</template>

<script>
import { useSessionStore } from '@/stores/sessionStore';

export default {
  setup() {
    const sessionstore = useSessionStore()

    return {
      sessionstore
    };
  },
  name: "CommunityResults",
  components: {
  },

  data() {
    return {
      ShowFinalPage: false,
      ShowExperiencePage: false,
      TextPlaceholders: [
        "L'azienda sembra avere scarsa attenzione nei confronti della community. Non riesce a coinvolgere e interagire in modo significativo con attuali e potenziali consumatori. La presenza online è limitata e poco partecipativa, e mancano iniziative per creare un senso di appartenenza e coesione tra i membri della community. Ci sono opportunità significative da cogliere per migliorare l'engagement e la partecipazione della community",
        "L'azienda sta cercando di coinvolgere la community, ma ci sono ancora margini di miglioramento. Le interazioni con i consumatori sono presenti, ma potrebbero essere più frequenti e significative. L'azienda potrebbe sfruttare meglio gli strumenti tradizionali e online per identificare e misurare la forza della propria community. Alcune iniziative sono state intraprese, ma c'è ancora spazio per una maggiore coesione e partecipazione della community",
        "L'azienda ha costruito una community solida e coinvolgente. Le interazioni con attuali e potenziali consumatori sono frequenti e significative, creando un forte legame tra i membri della community e il brand. Sfruttando una varietà di strumenti tradizionali e online, l'azienda è in grado di misurare e promuovere attivamente la coesione della community. Eventi auto organizzati e pagine social non ufficiali sono indicatori della forza e della vitalità della community. Congratulazioni all'azienda per aver costruito una gran bella community"
      ]
    };
  },
  methods: {
    showPage() {
      this.ShowFinalPage = true;
    },
    showPreviousPage() {
      this.ShowFinalPage = false;
      this.ShowExperiencePage = true;
    },
  }
};
</script>

<style lang="scss" scoped>
.search-results {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  min-height: 100vh;
  padding: 4rem 2rem;
}

.title-section {
  width: 100%;
  max-width: 1200px;
  text-align: left;
  margin-bottom: 3rem;

  h2 {
    font-size: 2.5rem;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 1rem;
  }

  h3 {
    font-size: 1.8rem;
    font-weight: 500;
    color: #1a1a1a;
  }

  .company-name {
    color: #2e4eed;
  }
}

.score-section {
  width: 100%;
  max-width: 1200px;
  margin-bottom: 3rem;
}

.score-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.score-title {
  font-size: 1.8rem;
  font-weight: 500;
  color: #1a1a1a;
}

.score-bar {
  width: 100%;
  height: 2rem;
  background-color: rgba(46, 78, 237, 0.1);
  border: 2px solid #2e4eed;
  overflow: hidden;
}

.score-fill {
  height: 100%;
  background-color: #2e4eed;
  transition: width 1s ease-in-out;
}

.score-value {
  font-size: 4rem;
  font-weight: 600;
  color: #2e4eed;
}

.score-feedback {
  width: 100%;
  max-width: 1200px;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.95);
  border: 2px solid #2e4eed;
  margin-top: 2rem;
}

.feedback-text {
  font-size: 1.8rem;
  font-weight: 500;
  color: #1a1a1a;
  line-height: 1.5;
  text-align: left;
}

@media (max-width: 768px) {
  .search-results {
    padding: 2rem 1rem;
  }

  .title-section {
    h2 {
      font-size: 2rem;
    }

    h3 {
      font-size: 1.5rem;
    }
  }

  .score-title {
    font-size: 1.5rem;
  }

  .score-value {
    font-size: 3rem;
  }

  .feedback-text {
    font-size: 1.5rem;
  }
}
</style>